import { PDFDownloadLink } from "@react-pdf/renderer";
import QRCodeDocument from "./QRCodeDocument";
import QRCodeDocument46 from "./QRCodeDocument46";
import {OutlineButton} from "app/components/atoms/button";

const QRCodePdf = ({ products, selectedFormat = "3/2" }) => {
    return (
        <div className="flex gap-2 items-center justify-center">
            <PDFDownloadLink
                document={<QRCodeDocument46 products={products} format="3/2" />}
                fileName="qrcode_4x6.pdf"
            >
                {({ loading }) => (loading ? "Loading..." : (<OutlineButton>QR Code 4x6</OutlineButton>))}
            </PDFDownloadLink>
            <PDFDownloadLink
                document={<QRCodeDocument products={products} format="5/2" />}
                fileName="qrcode_5x2.pdf"
            >
                {({ loading }) => (loading ? "Loading..." : (<OutlineButton>QR Code 5x2</OutlineButton>))}
            </PDFDownloadLink>
        </div>
    );
};

export default QRCodePdf;